import { WebTokenType } from '@ps/platform-message-framework/webtokenserver/WebTokenType';
import { ResolverTag, Size } from '@ps/web-core-store';
import React, { useContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import Iframe from '@swf/components/Iframe/Iframe';
import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import Translation from '@swf/components/Translation/Translation';
import useResolver from '@swf/core/hooks/useResolver';
import { select } from '@swf/core/store';

import { TXTCLI_Contact_Support } from './StarsHelp.messages.json';
import styles from './StarsHelp.scss';

const StarsHelp: React.FC = () => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const language = useSelector(select.locale.get);
  const brand = useSelector(select.cms.getBrandName);

  const { setStyle } = useContext<ModalContextValue>(ModalContext);

  const options = useMemo(
    () => ({
      tokenType: isAuthenticated ? WebTokenType.CUSTOMER_SUPPORT : WebTokenType.INVALID,
      query: { language, brand }
    }),
    [isAuthenticated, language, brand]
  );

  const contactSupportURL = useResolver(ResolverTag.ContactSupport, options);

  useEffect(() => {
    setStyle({ size: Size.LARGE });
  }, [setStyle]);

  return (
    <>
      <Header>
        <Translation {...TXTCLI_Contact_Support} />
        <CloseButton />
      </Header>
      <Body>
        <Iframe src={contactSupportURL} className={styles.contactSupportForm} scrolling="yes" />
      </Body>
    </>
  );
};

export default StarsHelp;
